/** TODO: Add types */
type StoryblokAddDataPayload = any;

export interface StoryblokActions {
    type: 'ADD_STORYBLOK_DATA';
    payload: StoryblokAddDataPayload;
}

export const addStoryblokData = (
    payload: StoryblokAddDataPayload,
): StoryblokActions => ({ payload, type: 'ADD_STORYBLOK_DATA' });
